
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue';

import useUsuarios from '@/modules/administracion/composables/useUsuarios';

export default {
    components: {
        UsuarioEditarComponent: defineAsyncComponent(
            () => import('@/modules/administracion/components/UsuarioEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerUsuarios,
            cambiarEstadoUsuario,
        } = useUsuarios();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Usuario', value: 'usuario', sortable: true },
            { text: 'Nombre completo', value: 'nombre_completo', sortable: true },
            { text: 'Correo electrónico', value: 'correo_electronico', sortable: true },
            { text: 'Rol', value: 'rol', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let usuarios: any = [];
        const usuariosFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const usuarioEditarComponentRef = ref();

        onMounted(async () => {
            await buscarUsuarios();
        });

        const buscarUsuarios = async () => {
            const resp = await obtenerUsuarios(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                usuarios = resp.data;
                usuariosFiltrados.value = JSON.parse(JSON.stringify(usuarios));
            }
        }

        const nuevoUsuario = async () => {
            usuarioEditarComponentRef.value.abrirComponent();
        }

        const editarUsuario = async (usuario: any) => {
            usuarioEditarComponentRef.value.abrirComponent(usuario.id_usuario);
        }

        const alternarEstadoUsuario = async (usuario: any) => {
            const resp = await cambiarEstadoUsuario(usuario.id_usuario, !usuario.estado);
            if (resp.ok) {
                await buscarUsuarios();
            }
        }

        const filtrarInformacion = async () => {
            usuariosFiltrados.value = JSON.parse(JSON.stringify(
                usuarios.filter(
                    (u: any) =>
                        u.usuario.toLowerCase().includes(textoFiltro.value.toLowerCase()) ||
                        u.nombre_completo.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarUsuarioComponentEmit = async (seGrabo: boolean) => {
            if (seGrabo) {
                await buscarUsuarios();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            usuariosFiltrados,

            buscarUsuarios,
            editarUsuario,
            alternarEstadoUsuario,
            filtrarInformacion,
            nuevoUsuario,

            usuarioEditarComponentRef,
            cerrarEditarUsuarioComponentEmit,
        };
    }
}
